import { render, staticRenderFns } from "./Cria_Usuario.vue?vue&type=template&id=5a253711&scoped=true&"
import script from "./Cria_Usuario.vue?vue&type=script&lang=js&"
export * from "./Cria_Usuario.vue?vue&type=script&lang=js&"
import style0 from "./Cria_Usuario.vue?vue&type=style&index=0&id=5a253711&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a253711",
  null
  
)

export default component.exports